export default (applicantId = null) => ({
    id: null,
    applicantId,
    state: '',
    identificationNumber: '',
    issueDate: '',
    expirationDate: ''
});